export default __webpack_public_path__ + "static/media/Savant's Leggings of the Exiled.2ec88687.jpg";